import { SAGA_ACTIONS } from '../../../_config'
import { DataTableTypes } from '../../../_config/types'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'
import { getZoneDesignDetailType } from './types/experimentApiTypes'

export function useExperimentApi() {
    const callApi = useApiCall()

    const createDesign = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.CREATE_DESIGN, data, onSuccess, onError)
    }

    const updateExperiment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPDATE_EXPERIMENT, data, onSuccess, onError)
    }

    const getExperiments = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.ZONE_DESIGN, data, onSuccess, onError)
    }

    const getuserdesign = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.USER_DESIGN, data, onSuccess, onError)
    }
    const getzonedesign = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.ZONE_DESIGN, data, onSuccess, onError)
    }

    const getZoneDesignDetail = <P, R>(data: getZoneDesignDetailType, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.ZONE_DESIGN_DETAILS, data, onSuccess, onError)
    }

    const getExperimentDetails = <P, R>(
        data: {
            literal: string
            use_orm?: boolean
            methodology?: string
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENT_DETAILS, data, onSuccess, onError)
    }

    const getContaminationCheck = <R>(
        data: {
            literal: string
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_CONTAMINATION_CHECK, data, onSuccess, onError)
    }

    const postContaminationSnapshot = <R>(
        data: {
            literal: string
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.POST_CONTAMINATION_SNAPSHOT, data, onSuccess, onError)
    }

    const updateContaminationSelection = <R>(
        data: {
            literal: string
            selected_experiment_ids: number[]
            expected_snapshot_revision: number
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPDATE_CONTAMINATION_SELECTION, data, onSuccess, onError)
    }

    const deleteContaminationSnapshot = <R>(
        data: {
            literal: string
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DELETE_CONTAMINATION_SNAPSHOT, data, onSuccess, onError)
    }

    const getExperimentDetailsWatch = <R>(
        data: {
            literal: string
            use_orm?: boolean
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENT_DETAILS_WATCH, data, onSuccess, onError)
    }

    const getFilterRestoreDetails: typeof getExperimentDetailsWatch = (data, onSuccess, onError) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_FILTER_RESTORE_DETAILS, data, onSuccess, onError)
    }

    const recurringFileProcessWatch = <R>(
        data: {
            literal: string
            use_orm?: boolean
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_FILE_PROCESS_WATCH, data, onSuccess, onError)
    }

    const getotherexperiments = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENTS_OTHERS, data, onSuccess, onError)
    }

    const getExperimentsAlt = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENTS, data, onSuccess, onError)
    }

    const getColumnPreviwData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_COLUMN_PREVIEW_DATA, data, onSuccess, onError)
    }

    const getFilterPreviwData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.FILTER_PREVIEW_DATA, data, onSuccess, onError)
    }

    const createUserDesign = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(
            SAGA_ACTIONS.EXPERIMENT.USER_DESIGN_CREATE,

            data,
            onSuccess,
            onError,
        )
    }
    const createRecurringExpt = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_EXPERIMENT_CREATE, data, onSuccess, onError)
    }
    const updateRecurringExpt = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_EXPERIMENT_UPDATE, data, onSuccess, onError)
    }

    const recurringUpdateDesignTable = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_UPDATE_DESIGN_TABLE, data, onSuccess, onError)
    }

    const recurringGetTableColumns = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_GET_DESIGN_TABLE_COLUMNS, data, onSuccess, onError)
    }

    const recurringGetDesignPreviewData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_GET_DESIGN_PREVIEW_DATA, data, onSuccess, onError)
    }

    const recurringUpdateConfig = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.RECURRING_UPDATE_DESIGN_CONFIG, data, onSuccess, onError)
    }

    const removeExperiment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.REMOVE_EXPERIMENT, data, onSuccess, onError)
    }
    const cancelExperiment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.CANCEL_EXPERIMENT, data, onSuccess, onError)
    }

    const uploadExperimentfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPLOAD_FILE, data, onSuccess, onError)
    }

    const uploadRecurringMeasurementFile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPLOAD_RECURRING_MEASUREMENT_FILE, data, onSuccess, onError)
    }

    const uploadAdditionalDataFile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPLOAD_ADDITIONAL_DATA_FILE, data, onSuccess, onError)
    }

    const mapAdditionalDataFile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MAP_ADDITIONAL_DATA_FILE, data, onSuccess, onError)
    }

    const getRctGroupResultS = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_RCT_GROUP_RESULTS, data, onSuccess, onError)
    }

    const exportRctGroupResultS = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXPORT_RCT_GROUP_RESULTS, data, onSuccess, onError)
    }

    const processValidateData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.PROCESS_VALIDATED_DATA, data, onSuccess, onError)
    }
    const getmeasurementdata = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MEASUREMENT_DATA, data, onSuccess, onError)
    }
    const getCardData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.CARDS, data, onSuccess, onError)
    }
    const getDMLCardData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DML_DATA, data, onSuccess, onError)
    }
    const getMTECardData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MTE_CARDS, data, onSuccess, onError)
    }
    const getDetailAndAnalysisData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DETAIL_ANALYSIS_DATA, data, onSuccess, onError)
    }
    const getSharedUsers = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.SHARED_USERS, data, onSuccess, onError)
    }
    const postShareUsers = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.SHARE_EXPT_TO_USERS, data, onSuccess, onError)
    }
    const executerct = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXECUTE_RCT, data, onSuccess, onError)
    }
    const executerctresult = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXECUTE_RCT_RESULTS, data, onSuccess, onError)
    }

    const getColumnsForGroupDristribution = <P, R>(
        data: {
            literal: string
            tableType: DataTableTypes
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_COLUMNS_FOR_GROUP_DISTRIBUTION, data, onSuccess, onError)
    }

    const getdesignkpimeasurment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_DESIGN_KPI_MEASURMENT, data, onSuccess, onError)
    }

    const executemeasurmentanalysis = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXECUTE_MEASURMENT_ANALYSIS, data, onSuccess, onError)
    }

    const executedesignmergeoverview = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MEASURMENT_DESIGN_MERGE_OVERVIEW, data, onSuccess, onError)
    }

    const getExperimentPieChartData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXEPERIMENT_PIE_CHART, data, onSuccess, onError)
    }

    const GetExperimentFromTheMarket = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENT_FROM_THE_MARKET, data, onSuccess, onError)
    }

    const mtesubmit = <P, R>(
        data: {
            literal: string
        },
        onSuccess: (resp: SuccessResponse<R>) => void,
        onError: (resp: ErrorResponse<R>) => void,
    ) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MTE_SUBMIT, data, onSuccess, onError)
    }

    const playOrPauseExpt = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.PLAY_OR_PAUSE, data, onSuccess, onError)
    }

    const getsqlPreviwData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.SQL_PREVIEW_DATA, data, onSuccess, onError)
    }
    const GetMeasurementGroupDistributionData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MEASUREMENT_GROUP_DISTRIBUTION_DATA, data, onSuccess, onError)
    }
    const migrateMeasurementDataToCsv = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MIGRATE_MEASUREMENT_DATA_TO_CSV, data, onSuccess, onError)
    }

    const downloadrctresult = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DOWNLOAD_RCT_GROUP_RESULTS, data, onSuccess, onError)
    }

    const GetDesignGroupDistributionData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DESIGN_GROUP_DISTRIBUTION_DETAILS, data, onSuccess, onError)
    }

    const Getkpichartdatabydate = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_KPI_CHART_DATA_BY_DATE, data, onSuccess, onError)
    }

    const Getobsfeaturedistributionbarchart = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_OBS_FEATURE_DISTRIBUTION_BAR_CHART, data, onSuccess, onError)
    }

    const Uploadexperimentfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT_FILES.UPLOAD_FILE, data, onSuccess, onError)
    }

    const Mapexperimentfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT_FILES.MAP_EXPERIMENT_FILES, data, onSuccess, onError)
    }
    const Deleteexperimentfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT_FILES.DELETE_FILES, data, onSuccess, onError)
    }

    const Downloadexperimentfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT_FILES.DOWNLOAD_FILES, data, onSuccess, onError)
    }
    const SampleSizeCalculate = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.SAMPLE_SIZE_CALCULATE, data, onSuccess, onError)
    }

    const getAvgMetricDesign = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.AVG_METRIC_DESIGN, data, onSuccess, onError)
    }
    const uploadadditionfile = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.ADDITIONAL_FILE_UPLOAD, data, onSuccess, onError)
    }
    const getadditionaltabledata = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.ADDITIONAL_TABLE_DATA, data, onSuccess, onError)
    }
    const getComments = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_COMMENTS, data, onSuccess, onError)
    }
    const postComment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.POST_COMMENT, data, onSuccess, onError)
    }
    const getInconclusiveReason = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_INCONCLUSIVE_REASON, data, onSuccess, onError)
    }
    const downloadLog = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DOWNLOAD_LOG, data, onSuccess, onError)
    }

    const makePartial = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MAKE_PARTIAL, data, onSuccess, onError)
    }
    const experimentDropDownData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXPERIMENT_DROPDOWN, data, onSuccess, onError)
    }

    const deleteInsights = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DELETE_INSIGHTS, data, onSuccess, onError)
    }

    const updateUnitAPI = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPDATE_KPI_UNIT, data, onSuccess, onError)
    }
    const generateDataQualityReport = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GENERATE_DATA_QUALITY_REPORT, data, onSuccess, onError)
    }
    const markasBuPriority = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.MARK_AS_BU_PRIORITY, data, onSuccess, onError)
    }
    const shareableUserList = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.SHARABLE_USER_LIST, data, onSuccess, onError)
    }
    const experimentsSharedWidthMe = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXPERIMENTS_SHARED_WITH_ME, data, onSuccess, onError)
    }

    const getRecurringTableDataPreview = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_RECURRING_TABLE_DATA_PREVIEW, data, onSuccess, onError)
    }

    const getRecurringColumnsData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_RECURRING_COLUMNS_DATA, data, onSuccess, onError)
    }

    const getRecurringRequiredColumnList = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_RECURRING_REQUIRED_COLUMN_LIST, data, onSuccess, onError)
    }

    const GetRecurringMeasurementGroupDistributionData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_RECURRING_MEASUREMENT_GROUP_DISTRIBUTION_DATA, data, onSuccess, onError)
    }
    const updateRecurringExperiment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPDATE_RECURRING_EXPERIMENT, data, onSuccess, onError)
    }

    const updateKpiDirection = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPDATE_KPI_DIRECTION, data, onSuccess, onError)
    }
    const getExperimentInsideMethodology = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENT_INSIDE_METHODOLOGY, data, onSuccess, onError)
    }
    const deleteExperimentChild = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DELETE_EXPERIMENT_CHILD, data, onSuccess, onError)
    }

    const getSchedulingDetesForRecurringExperiment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_SCHEDULE_DATES_FOR_RECURRING_EXPERIMENT, data, onSuccess, onError)
    }

    const deleteRecurringExperimentChild = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DELETE_RECURRING_EXPERIMENT_CHILD, data, onSuccess, onError)
    }

    const updateRecurringDateConfig = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.UPDATE_RECURRING_DATE_CONFIG, data, onSuccess, onError)
    }
    const getExperimentMasterDecision = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENT_MASTER_DECISION, data, onSuccess, onError)
    }

    const saveExperimentDecision = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.SAVE_EXPERIMENT_DECISION, data, onSuccess, onError)
    }
    const editExperiment = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.EXPERIMENT_EDIT, data, onSuccess, onError)
    }
    const downloadRctGZipResults = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.EXPERIMENT.DOWNLOAD_RCT_GZIP_RESULTS, data, onSuccess, onError)
    }

    return {
        createDesign,
        createUserDesign,
        getzonedesign,
        getuserdesign,
        getZoneDesignDetail,
        getExperiments,
        getExperimentDetails,
        getContaminationCheck,
        postContaminationSnapshot,
        updateContaminationSelection,
        deleteContaminationSnapshot,
        getotherexperiments,
        updateExperiment,
        getExperimentsAlt,
        getColumnPreviwData,
        getFilterPreviwData,
        uploadExperimentfile,
        uploadAdditionalDataFile,
        mapAdditionalDataFile,
        removeExperiment,
        cancelExperiment,
        getRctGroupResultS,
        exportRctGroupResultS,
        processValidateData,
        getmeasurementdata,
        getCardData,
        getDMLCardData,
        getMTECardData,
        getDetailAndAnalysisData,
        getSharedUsers,
        postShareUsers,
        executerct,
        executerctresult,
        getColumnsForGroupDristribution,
        getExperimentDetailsWatch,
        getFilterRestoreDetails,
        getdesignkpimeasurment,
        executemeasurmentanalysis,
        executedesignmergeoverview,
        getExperimentPieChartData,
        GetExperimentFromTheMarket,
        mtesubmit,
        createRecurringExpt,
        updateRecurringExpt,
        playOrPauseExpt,
        getsqlPreviwData,
        GetMeasurementGroupDistributionData,
        migrateMeasurementDataToCsv,
        downloadrctresult,
        GetDesignGroupDistributionData,
        Getkpichartdatabydate,
        Getobsfeaturedistributionbarchart,
        Uploadexperimentfile,
        Mapexperimentfile,
        Deleteexperimentfile,
        Downloadexperimentfile,
        SampleSizeCalculate,
        getAvgMetricDesign,
        getadditionaltabledata,
        uploadadditionfile,
        getComments,
        postComment,
        getInconclusiveReason,
        downloadLog,
        makePartial,
        deleteInsights,
        experimentDropDownData,
        recurringUpdateDesignTable,
        recurringGetTableColumns,
        recurringGetDesignPreviewData,
        recurringUpdateConfig,
        updateUnitAPI,
        generateDataQualityReport,
        markasBuPriority,
        shareableUserList,
        experimentsSharedWidthMe,
        getExperimentInsideMethodology,
        getRecurringTableDataPreview,
        deleteExperimentChild,
        getRecurringColumnsData,
        getRecurringRequiredColumnList,
        GetRecurringMeasurementGroupDistributionData,
        uploadRecurringMeasurementFile,
        recurringFileProcessWatch,
        updateRecurringExperiment,
        updateKpiDirection,
        getSchedulingDetesForRecurringExperiment,
        deleteRecurringExperimentChild,
        updateRecurringDateConfig,
        getExperimentMasterDecision,
        saveExperimentDecision,
        editExperiment,
        downloadRctGZipResults,
    }
}
